import Tabs from 'components/Tabs';
import CommandPalette from 'components/ui/CommandPalette';
import Header from 'components/ui/Header';
import Sidebar from 'components/ui/Sidebar';
import { motion } from 'framer-motion';
import SalaryTab from './components/SalaryTab';
import AttendanceTab from './components/AttendanceTab';

const AttendanceAndSalary = () => {
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 },
    },
  };
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-background to-secondary-50">
      <Header />
      <Sidebar />
      <CommandPalette />

      <main className="lg:ml-60 pt-16">
        <motion.div
          className="px-4 sm:px-6 lg:px-8 pt-4 lg:pt-8 pb-4"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.div className="mb-4" variants={itemVariants}>
            <h1 className="text-3xl font-bold text-text-primary mb-2">Attendance & Salary</h1>
            <p className="text-text-secondary">
              Manage employee&apos; attendance records and salaries
            </p>
          </motion.div>
          <Tabs
            tabs={[
              {
                label: 'Attendance',
                key: 'attendance',
                content: <AttendanceTab />,
              },
              {
                label: 'Salary',
                key: 'salary',
                content: <SalaryTab />,
              },
            ]}
            defaultTab="attendance"
            variant="underline"
          />
        </motion.div>
      </main>
    </div>
  );
};

export default AttendanceAndSalary;
